import { render } from "./recurring-invoices.vue?vue&type=template&id=82adf7ee"
import script from "./recurring-invoices.vue?vue&type=script&lang=js"
export * from "./recurring-invoices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__